import { Typography } from 'antd';

export const SectionTitleRequired = ({ title }: { title: string }) => (
  <Typography.Title level={5} style={{ fontWeight: 500 }}>
    {title} <span style={{ color: 'red' }}>*</span>
  </Typography.Title>
);
